module.exports = __webpack_public_path__ + "static/media/taipingshan_package.fb506a7e.webp";